var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "item-container", on: { click: _setup.goToAction } },
    [
      _c("div", { staticClass: "item" }, [
        _c(
          "div",
          { staticClass: "info-1" },
          [
            _setup.isTruncated
              ? _c(
                  _setup.LexonTooltipComponent,
                  {
                    staticClass: "tooltip-activator caso1",
                    attrs: {
                      message: _vm.action.subject,
                      position: "top",
                      isWidthAuto: "",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "row-1",
                        attrs: { slot: "activator-element" },
                        slot: "activator-element",
                      },
                      [
                        _c("span", { class: [_setup.icon, "lf-icon__md"] }),
                        _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(_vm.action.subject)),
                        ]),
                      ]
                    ),
                  ]
                )
              : _c(
                  "div",
                  { ref: "textContainerElement", staticClass: "row-1 caso2" },
                  [
                    _c("span", { class: [_setup.icon, "lf-icon__md"] }),
                    _c("span", { ref: "textElement", staticClass: "name" }, [
                      _vm._v(_vm._s(_vm.action.subject)),
                    ]),
                  ]
                ),
            _c("div", { staticClass: "row-2" }, [
              _c("div", { staticClass: "description-container" }, [
                _c("span", { staticClass: "description" }, [
                  _vm._v(_vm._s(_vm.action.description ?? "-")),
                ]),
              ]),
              _c("span", { staticClass: "name" }, [
                _vm._v(
                  _vm._s(_vm.action.expedientName ?? _setup.text.noExpedient)
                ),
              ]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "info-2" },
          [
            _c("div", { staticClass: "text-container" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.action.customerName,
                      expression: "action.customerName",
                    },
                  ],
                  staticClass: "text",
                },
                [_vm._v(_vm._s(_vm.action.customerName) + " ")]
              ),
            ]),
            _c("v-spacer"),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.action.dueDate,
                    expression: "action.dueDate",
                  },
                ],
                staticClass: "date",
              },
              [_vm._v(_vm._s(_setup.renderDate(_vm.action.dueDate)))]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }